import { TextField } from "@mui/material";

const InputText = (props) => {
  return (
    <TextField
      {...props}
      variant={"standard"}
      fullWidth
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};

export default InputText;
